<template>
	<TopTab />

	<van-swipe class="my-swipe" :autoplay="3000" :show-indicators="false">
		<van-swipe-item v-for="item in bannerList" :key="item">
			<div class="banner" :style="{ backgroundImage: `url(${item})` }"></div>
		</van-swipe-item>
	</van-swipe>

	<Title title="鉴宝要闻" url="/art-more?type=3" />

	<ul class="list2">
		<li>
			<NewsItem2 :data="newsList[0] || {}" @click="router.push({ path: '/art-detail', query: { id: newsList[0].id } })"/>
			<div class="row" v-for="item in newsList.slice(2, 4)" :key="item.id" @click="router.push({ path: '/art-detail', query: { id: item.id } })">
				<i></i>
				<p>{{ item.title }}</p>
				<!-- <span>{{ item.readCount }}</span> -->
			</div>
		</li>
		<li>
			<NewsItem2 :data="newsList[1] || {}" @click="router.push({ path: '/art-detail', query: { id: newsList[1].id } })" />
			<div class="row" v-for="item in newsList.slice(4, 6)" :key="item.id" @click="router.push({ path: '/art-detail', query: { id: item.id } })">
				<i></i>
				<p>{{ item.title }}</p>
				<!-- <span>{{ item.readCount }}</span> -->
			</div>
		</li>
	</ul>

	<div style="background-color: #F9F9F9; padding: 30rem 0 60rem 0; margin: 30rem 0">
		<Title title="文物专题" url="/art-more?type=1"/>
		<ul class="wwzt">
			<li v-for="(item, index) in modelList" :key="index" :style="{ backgroundImage: `url(${['https://www.bolanzg.com/assets/bg01-Ds-hzqgC.png', 'https://www.bolanzg.com/assets/bg02-ieo3qCJH.png', 'https://www.bolanzg.com/assets/bg03-ez70wxrG.png'][index]})` }">
				<img :src="item.picUrl" alt="" @click="router.push({ path: '/art-detail', query: { id: item.id } })">
				<p>{{ item.title }}</p>
			</li>
		</ul>
	</div>

	<Title title="人物专题" url="/art-more?type=2"/>
	<ul class="characterList">
		<li v-for="(item, index) in characterList" :key="index" @click="router.push({ path: '/art-detail', query: { id: item.id } })">
			<img :src="item.picUrl" alt="">
			<p>{{ item.title }}</p>
		</li>
	</ul>

	<div style="background-color: #F9F9F9; padding: 30rem 0 60rem 0; margin: 30rem 0">
		<Title title="资讯杂谈" url="/art-more?type=4"/>
		<ul class="news">
			<li v-for="(item, index) in newsList2" :key="index" @click="router.push({ path: '/art-detail', query: { id: item.id } })">
				<NewsItem :data="item || {}" :url="'/art-detail?id=' + item.id" />
			</li>
		</ul>
	</div>

	<FooterBar />
</template>

<script setup>
import TopTab from '@/views/front/components/TopTab.vue'
import { onMounted, ref, watch, reactive } from 'vue'
import { useRouter } from 'vue-router'
import * as api from '@/request/front'
import { richTextToPlainText } from '@/utils/util.js'
import NewsItem from '@/views/front/components/NewsItem.vue'
import NewsItem2 from '@/views/front/components/NewsItem2.vue'
import FooterBar from '@/views/front/components/FooterBar.vue'
import Title from '@/views/front/components/Title.vue'
import { http } from '@/request/http'
const router = useRouter()
const bannerList = ref([])
const informationChatList = ref([])
onMounted(() => {
	http.get('/app-api/promotion/article/get-banner').then(res => {
		bannerList.value = res
	})
	fetchNewsList()
	getModelList()
	getCharacterList()
	getInformationChatList()
})
// 获取鉴宝要闻
const newsList = ref([])
function fetchNewsList() {
	http.get('/app-api/promotion/article/page?returnType=2&pageNo=1&pageSize=6&sortType=2&categoryId=3').then(res => {
		newsList.value = res.list
	}).catch(err => {
		showNotify('服务器连接错误')
	})
}
// 获取文物专题
const modelList = ref([])
function getModelList() {
	http.get('/app-api/promotion/article/page?returnType=2&pageNo=1&pageSize=3&sortType=2&categoryId=1').then(res => {
		modelList.value = res.list
	}).catch(err => {
		showNotify('服务器连接错误')
	})

}
// 获取人物专题
const characterList = ref([])
function getCharacterList() {
	http.get('/app-api/promotion/article/page?returnType=2&pageNo=1&pageSize=4&sortType=1&categoryId=2').then(res => {
		characterList.value = res.list
	}).catch(err => {
		showNotify('服务器连接错误')
	})
}
// 获取资讯杂谈
const newsList2 = ref([])
function getInformationChatList() {
	http.get('/app-api/promotion/article/page?returnType=2&pageNo=1&pageSize=2&sortType=1&categoryId=4').then(res => {
		console.log(res);
		
		newsList2.value = res.list
	}).catch(err => {
		showNotify('服务器连接错误')
	})
}



</script>

<style scoped lang="scss">
.my-swipe {
	width: 100%;
	height: 160rem;

	.banner {
		width: 100%;
		height: 100%;
		background-size: cover;
		background-position: center;
	}
}

.list2 {
	display: flex;
	padding: 0 15rem;
	justify-content: space-between;

	>li {
		width: calc(50% - 7rem);

		.row {
			display: flex;
			align-items: center;
			height: 40rem;
			border-bottom: 1px dashed #E3E3E3;

			i {
				display: block;
				width: 8rem;
				height: 8rem;
				background-color: #DBDBDB;
				border-radius: 4rem;
				flex-shrink: 0;
				margin-right: 10rem;
			}

			p {
				font-size: 12rem;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				color: #333;
			}
		}
	}

}

.wwzt {
	display: flex;
	justify-content: space-between;
	padding: 15rem;
	
	li {
		width: 124rem;
		height: 160rem;
		background-size: cover;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		img{
			width: 80%; height: 80%; object-fit: contain; position: relative; z-index: 1;
		}
		p{
			writing-mode: vertical-rl;
			text-orientation: upright;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			position: absolute;
			top: 5rem;
			left: 2rem;
			font-size: 12rem;
			color: #333;
			z-index: 1;
			overflow: hidden;
			height: 90%;
		}
	}

	li:nth-child(2) {
		transform: translateY(25rem);

	}

	li::after {
		content: '';
		display: block;
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 60rem;

	}

	li:nth-child(1)::after {
		background-color: #d1c5af;
	}

	li:nth-child(2)::after {
		background-color: #f3f2e0;
	}

	li:nth-child(3)::after {
		background-color: #e6eaeb;
	}
}

.characterList{
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	grid-gap: 10rem;
	justify-content: space-between;
	padding: 15rem;
	li{
		// width: 100rem;
		img{
			width: 100%; height: 100rem; object-fit: cover; position: relative; z-index: 1;
		}
		p{
			color: #333; font-size: 14rem; line-height: 30rem; padding: 0 5rem;
		}
	}

}
</style>
